import React from "react";
import { Suspense } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { Login } from "./pages/Auth/Login";
import { ReviewerDashboard } from "./pages/Reviewer/ReviewerDashboard";
import { Register } from "./pages/Auth/Register";
import { ForgetPassword } from "./pages/Auth/ForgetPassword";
import { ResetPassword } from "./pages/Auth/ResetPassword";
import { AccountActive } from "./pages/Auth/AccountActive";
import { IncorrectCode } from "./pages/Auth/IncorrectCode";

const UnAuthenticatedApp = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<div></div>}>
        <Switch>
          <Redirect path="/logout" to="/" exact />
          <Route
            path="/register/:token"
            exact
            render={props => <Register {...props} />}
          />

          <Route
            path="/forget-password"
            exact
            render={props => <ForgetPassword {...props} />}
          />
          <Route
            path="/account-active"
            exact
            render={() => <AccountActive />}
          />
          <Route
            path="/incorrect-code"
            exact
            render={() => <IncorrectCode />}
          />
          <Route
            path="/reset-password/:resetKey"
            exact
            render={props => <ResetPassword {...props} />}
          />
          <Route
            path="/dashboard/reviewer"
            exact
            render={props => <ReviewerDashboard {...props} />}
          />
          <Route path="/" exact render={props => <Login {...props} />} />
          <Redirect path="/**" to="/" exact />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default UnAuthenticatedApp;
